// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"32aa8d78","438":"2a4f1897","453":"248d8269","642":"5f887283","968":"bbdb0550"}[chunkId] + ".chunk.js";
};